/* eslint-disable tailwindcss/no-arbitrary-value */
import InfoCircle from '$/components/icons/InfoCircle';

type ProductAttributeProps = {
  label?: string;
  prefix?: string;
  suffix?: string;
  value?: number | string;
  tooltipContent?: string;
  classNameWrapper?: string;
  classNameLabel?: string;
  attributeType?: string;
  isHighlight?: boolean;
};

export default function ProductAttribute({
  label,
  prefix,
  value,
  suffix,
  tooltipContent,
  classNameWrapper,
  classNameLabel = '',
  attributeType,
  isHighlight = false,
}: ProductAttributeProps): JSX.Element {
  return (
    <div className={`${classNameWrapper}`} data-property-type={attributeType}>
      <span
        className={`mhg-alpha-body-2 text-[--text-secondary-lighter] ${classNameLabel}`}
      >
        {label}
      </span>
      <div className="flex flex-1 shrink-0 basis-0 items-center gap-1">
        <span
          className={`mhg-alpha-bullet-2 ${isHighlight ? 'rounded-[28px] px-[--spacing-padding-x-sm] py-[--button-padding-toggle] text-center bg-[--fill-primary-light] text-[--fill-primary-dark]' : 'text-[--text-primary]'}`}
        >
          {prefix}
          {value}
          {suffix}

          {tooltipContent && (
            <span className="group relative">
              {' '}
              <InfoCircle className="inline size-shapes/icon-size-md text-[color:--colors-neutral-gray-700] text-[length:--shapes-icon-size-md]" />
              <div className="mhg-alpha-caption absolute bottom-full left-1/2 mb-2 hidden w-max max-w-50 -translate-x-1/2 rounded-lg p-3 opacity-0 shadow transition-opacity duration-200 bg-white text-[--text-primary] text-sm group-hover:block group-hover:opacity-100 md:max-w-75">
                {tooltipContent}
              </div>
            </span>
          )}
        </span>
      </div>
    </div>
  );
}
